import { useMutation } from "@tanstack/react-query";
import { addSet } from "api-client";

import { useAuthenticatedNavigationContext } from "src/layout/AuthenticatedNavigationContext";

import { useWorkoutItemMutationScope } from "./useWorkoutItemMutationScope";
import { useWorkoutEditStore } from "./WorkoutEditContext";

interface AddSetInput {
  workoutItemId: string;
  order: number;
}

export function useAddSet(workoutItemId: string) {
  const workoutEditStore = useWorkoutEditStore();
  const scope = useWorkoutItemMutationScope(workoutItemId);
  const { startSaving } = useAuthenticatedNavigationContext();

  const mutation = useMutation({
    scope,
    mutationFn: (arg: AddSetInput) => {
      return addSet({
        path: {
          workoutId: workoutEditStore.workout.id,
          workoutItemId: arg.workoutItemId,
        },
        body: { order: arg.order },
      });
    },
  });

  function perform(workoutItemId: string, order: number) {
    if (mutation.isPending) {
      return;
    }

    const stop = startSaving();

    mutation.mutate(
      { workoutItemId, order },
      {
        onSuccess: (response) => {
          const data = response.data.data;
          workoutEditStore.addWorkoutSets([
            data.newWorkoutSet,
            ...data.newAlternateWorkoutSets,
          ]);
          stop();
        },
        onError: () => {
          stop("error");
        },
      },
    );
  }

  return {
    mutation,
    perform,
  };
}
